import { defineComponent } from '@vue/composition-api';
import { Radio as ElRadio, RadioGroup } from '@ks/ks-element-ui';
import { emitChange } from '@/components/form/utils/emit';
import { SpecificPropsType } from '@/components/form/types';

export type Id =
    | {
          id: string;
          name: string;
      }
    | string;

export const Radio = defineComponent({
    props: {
        value: String,
        list: Array,
    } as unknown as SpecificPropsType<{
        value: string;
        list?: Id[];
        api?(): Promise<Id[]>;
    }>,
    setup: (props, { emit }) => {
        const list = props.list || [];
        return () => {
            return (
                <RadioGroup value={props.value} onInput={emitChange(emit)}>
                    {list.map((it) =>
                        typeof it === 'string' ? (
                            <ElRadio
                                style="margin-bottom: 0;margin-right: 32px;color: rgba(35,40,54,1)"
                                label={it}
                            >
                                {it}
                            </ElRadio>
                        ) : (
                            <ElRadio
                                style="margin-bottom: 0;margin-right: 32px"
                                label={it.id}
                            >
                                {it.name}
                            </ElRadio>
                        ),
                    )}
                </RadioGroup>
            );
        };
    },
});
